import React from 'react';
import { Card } from './Card';
import { DateRange } from '../common/DateRange';

export const CardProfile = ({data, id, model, matchedQueries}) => {
  const header = (
    <React.Fragment>
      {data.first_name} {data.last_name}
    </React.Fragment>
  );

  const meta = <DateRange start={data.birth_date} end={data.death_date} />;

  return (
    <Card model={model} header={header} color='blue' meta={meta} id={id} matchedQueries={matchedQueries}/>
  );
};